<template>
<div>
  <div class="card" v-if="!isLoading">
    <v-row  class="d-flex align-center">
      <div class="icon">
        <v-icon v-if="icon">{{icon}}</v-icon>
      </div>
      <div><slot></slot></div>
    </v-row>
  </div>

    <div v-else class="card">
      <oneLine v-if="type==='oneLine'" />
      <twoLine v-else-if="type==='twoLine'" />
      <fourLineMap v-else-if="type==='fourLineMap'" />
    </div>

  </div>
</template>

<script>
import oneLine from '@/components/placeholders/oneLine'
import twoLine from '@/components/placeholders/twoLine'
import fourLineMap from '@/components/placeholders/fourLineMap'

export default {
  name: 'slotCard',
  components: {
    oneLine,
    twoLine,
    fourLineMap
  },
  props: {
    icon: String,
    isLoading: Boolean,
    type: String
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
  .card {
    border: 1px solid black;
    padding: 10px;
    //  inline-block so the width depends on the content
    display: inline-block;
  }
  .icon {
    min-width: 40px
  }
</style>
